export function pushga(data: {
  event?: string;
  eventCategory: string;
  eventAction?: string;
  eventLabel?: string;
}) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (!data.event && data.eventCategory) data.event = data.eventCategory;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  } catch (error) {
    console.error(error);
  }
}

export function pushEcommerceGAEvent({
  event = '',
  virtualPage = '',
  pageViewEvents = {},
  path=''
}:{
  event?:string;
  virtualPage:string;
  pageViewEvents?:object;
  path?:string;

}) {
  try {
    if (typeof window === 'undefined') {
      return;
    }
    if (typeof window === 'object' && window.window === window) {
      window.dataLayer = window.dataLayer || [];
      const dataLayerObj = {
        event: 'virtualPageView',
        virtualPage: virtualPage,
        path:path,
        ...pageViewEvents
      };
      if (event) {
        dataLayerObj.event = event;
      }
      dataLayer.push(dataLayerObj);
    }
  } catch (err) {
    console.log('err in gaPageViewTracking', err);
    console.trace(err);
  }
}
